import { IUser } from '@interfaces/IUser';

export interface IProfileState {
  errors: { [key: string]: { [key: string]: string[] } };
  messages: { [key: string]: string };
  isValidToken: boolean;
  loading?: { [key: string]: boolean };
  user: IUser;
  success?: boolean;
}

export const initialProfileState: IProfileState = {
  errors: {},
  messages: {},
  isValidToken: false,
  user: {},
  success: false,
};
